import { createSlice } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import {
    createStrapiMediaUrl,
    fetchLeadFormThunk,
    fetchSweetShopArticleCategoriesThunk,
} from 'shared/lib';
import { CakeToOrderCardModelSchema } from 'entities/cake-to-order';
import { SweetShopPageState } from './state';
import { GetSweetShopServiceActionResponseMapper, SweetShopPageActions } from './actions';
import BaseError from '../../../utils/base-error';
import { createSweetShopArticleCategoriesFromGetSweetShopArticleCategoriesApiResponse } from '../utils';

const initialState: SweetShopPageState = {
    loaded: false,
    errors: [],
    sweetShopArticleCategories: [],
    cakeToOrderCards: [],
    title: 'Кондитерская',
    image: {
        url: '', // TODO
    },
};

export const sweetShopPageSlice = createSlice({
    name: 'sweetShopPageSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        /**
         * Обработчик получения списка типов баров (коллекция OutdoorBarType)
         */
        builder.addCase(
            fetchSweetShopArticleCategoriesThunk.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = createSweetShopArticleCategoriesFromGetSweetShopArticleCategoriesApiResponse(
                            response.data,
                        );

                        state.sweetShopArticleCategories = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            SweetShopPageActions.getSweetShopService.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    try {
                        state.title = GetSweetShopServiceActionResponseMapper.getTitle(
                            response,
                        );
                        state.description = GetSweetShopServiceActionResponseMapper.getDescription(
                            response,
                        );
                        state.image = GetSweetShopServiceActionResponseMapper.getImage(
                            response,
                        );
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
        builder.addCase(
            fetchLeadFormThunk.fulfilled,
            (state, action) => {
                const response = action.payload;
                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    state.leadFormPdf = response.data.data.commercialOfferFile ? {
                        url: createStrapiMediaUrl(response.data.data.commercialOfferFile.url),
                    } : undefined;

                    state.loaded = true;
                }
                state.loaded = true;
            },
        );
        builder.addCase(
            SweetShopPageActions.getCakeToOrderCards.fulfilled,
            (state, action) => {
                const response = action.payload;

                if (response instanceof BaseError) {
                    state.errors.push(response);
                } else {
                    // Валидация
                    try {
                        // eslint-disable-next-line max-len
                        const result = response.data.data.map(({
                            slug,
                            name,
                            description,
                            images,

                        }) => CakeToOrderCardModelSchema.parse({
                            uid: slug,
                            name,
                            description,
                            image: images?.[0] && {
                                url: images[0].url,
                            },
                        }));
                        state.cakeToOrderCards = result;
                        state.loaded = true;
                    } catch (e) {
                        state.errors.push(new BaseError(400, String(e)));
                    }
                }
            },
        );
    },
});
